// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"caea7d71","134":"f9f118f1","315":"68ab21bb","380":"7fac673c","668":"6b65bc7f","787":"f88a7bd3","815":"24e84505"}[chunkId] + ".chunk.js";
};